module.exports = __webpack_public_path__ + "static/img/home_icon3.c487ec7d.png";